module.exports = __webpack_public_path__ + "img/74.6.CODm.a762bdfb.png";